import { Injectable } from "@angular/core";
import { ClientService } from "../services/client.service";
import { ArrayClientRepository } from "./abstract/array.client.repository";
import { Tab } from "../types/Tab/Tab";

@Injectable({
  providedIn: "root",
})
export class IrefTabsRepository extends ArrayClientRepository<Tab> {
  constructor(clientService: ClientService) {
    super(clientService, "schemas.schCFG_IREF_Tabs.records", "tabID");
  }

  public getIrefInspectionTabs(): Tab[] {
    return super.getFilteredByValue("fkey", "inspectionID");
  }

  public getIrefTabsByInspectionTypeID(inspectionTypeID: string): Tab[] {
    return super.getFilteredByValues(
      ["inspectionTypeID", "fkey"],
      [inspectionTypeID, "inspectionID"],
    );
  }
}
